import {IFormComparatorResponse, IServerData} from "~/interfaces/serverInterfaces";
import Selected from "../../../formability/form_builder/store/modules/selected";
import {IFormMergeModule} from "~/interfaces/vuexModuleInterfaces";

export default function (): IFormMergeModule {
  return {
    actions: {
      diff({commit, state}, payload): Promise<IFormComparatorResponse> {
        const selectedForm = Selected.form.get();
        return new Promise((resolve, reject) => {
          selectedForm.runWithProvider(provider => {
            provider.diff(selectedForm, payload).then(
              ([response]) => {
                resolve(response);
              });
          });
        });
      },

      merge({commit, state}, payload): Promise<IServerData> {
        const selectedForm = Selected.form.get();
        return new Promise((resolve, reject) => {
          selectedForm.runWithProvider(provider => {
            provider.merge(selectedForm, payload).then(resolve);
          });
        });
      },

    }
  };
}